import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { useDispatch } from 'react-redux'
import styles from './styles'
import { Typography, Divider } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import { CoreButton } from 'src/components/core'
const OtherProjects = props => {
  const dispatch = useDispatch()
  const { classes } = props
  const redirectTo = project => {
    if (project === 'knowup') {
      window.open('https://knowup.io/', '_blank')
    } else {
      window.open('https://quizcube.io/', '_blank')
    }
  }
  return (
    <div className={classes.page}>
      <div className={classes.pageHeader}>
        <div className={classes.ourDiv}>
          <Typography color="#fff" fontSize={'15px'} fontWeight={600}>
            Our
          </Typography>
        </div>
        <Typography fontSize={'32px'} fontWeight={700}>
          Other Products
        </Typography>
      </div>
      <div className={classes.contentDiv}>
        <div className={classes.contentDivItem}>
          <img className={classes.logos} src="/assets/know-up-black.png" />
          <Typography
            textAlign={'center'}
            fontSize={'15px'}
            fontWeight={600}
            className={classes.mb}
          >
            Run your academy directly on Discord with the KnowUp Discord App.
          </Typography>
          <CoreButton onClick={() => redirectTo('knowup')} variant="outlined">
            Learn More
          </CoreButton>
        </div>
        <Divider orientation={isMobile && 'vertical'}></Divider>
        <div className={classes.contentDivItem}>
          <img className={classes.logos} src="/assets/qc-logo.svg" />
          <Typography
            textAlign={'center'}
            fontSize={'15px'}
            fontWeight={600}
            className={classes.mb}
          >
            Speed up creating quizzes with <br />
            AI Quiz Generator.
          </Typography>
          <CoreButton
            onClick={() => redirectTo()}
            variant="outlined"
            className={classes.buttons}
          >
            Learn More
          </CoreButton>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(OtherProjects)
